import React from 'react';
import { Pill } from 'day8-ui';
import { FaFireFlameCurved } from '@react-icons/all-files/fa6/FaFireFlameCurved';

const getColourClass = limit => {
  if (limit === 0) return '!dui-bg-red-500';
  if (limit > 1) return '!dui-bg-orange-400';
  return '!dui-bg-orange-600';
};

export const UrgencyPill = ({ limit, className = "" }) => {
  if (typeof limit !== 'number' || !Number.isFinite(limit)) return null;
  return <Pill className={`${getColourClass(limit)} ${className}`} leftIcon={<FaFireFlameCurved />}>{limit} left</Pill>;
};
export default UrgencyPill;
